import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const rootElement = document.getElementById("root");

// Preserve SSG blog content BEFORE React mounts (createRoot wipes #root content)
// This allows BlogArticlePage to detect and use the pre-rendered SSG content
(function preserveSsgBlogContent() {
  const rootHtml = rootElement.innerHTML;
  // Match SSG blog marker - slug can contain hyphens, so use non-greedy match until -->
  const ssgBlogMatch = rootHtml.match(/<!--ssg-blog-(.+?)-->/);
  
  if (ssgBlogMatch) {
    const slug = ssgBlogMatch[1];
    const h1Element = rootElement.querySelector('article h1');
    const contentDiv = rootElement.querySelector('#article-content');
    const relatedBlock = rootElement.querySelector('[data-testid="weiterfuehrende-seiten"]');
    
    window.__SSG_BLOG__ = {
      slug: slug,
      h1: h1Element ? h1Element.textContent.trim() : null,
      content: contentDiv ? contentDiv.innerHTML : null,
      relatedCategory: relatedBlock ? relatedBlock.getAttribute('data-category') : null,
      detected: true
    };
  }
})();

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
